import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from 'store/actions';
import { VideoRecorder } from 'components';
import { withRouter } from './with-router-proxy';
import _ from 'lodash';
import qs from 'query-string';

const DEFAULT_VIDEO_WIDTH = 1280;
const DEFAULT_VIDEO_HEIGHT = 720;

class Recorder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recordingData: null,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    if (this.props?.router?.location?.search) {
      let queryStringParams = qs.parse(this.props.router?.location.search);
      let recordingInputUrl = queryStringParams.input;
      if (recordingInputUrl) {
        this.props.getRecordingData(recordingInputUrl);
        this.setState({
          width:
            (queryStringParams.width && parseInt(queryStringParams.width)) ||
            DEFAULT_VIDEO_WIDTH,
          height:
            (queryStringParams.height && parseInt(queryStringParams.height)) ||
            DEFAULT_VIDEO_HEIGHT,
          webmrecording: queryStringParams.webmrecording
            ? queryStringParams.webmrecording === 'True'
            : false,
          framesdestination: queryStringParams.framesdestination,
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      (this.state.recordingData && !prevState.recordingData) ||
      (this.props.recordingData && !prevProps.recordingData)
    ) {
      window.recorderLoaded = true;
    }
  }

  onLoadClicked = () => {
    if (window.recordParams) {
      const { renderParams, webmRecording, framesDestination, loadImages } =
        window.recordParams;
      if (loadImages) {
        this.props.loadRecordingImages(renderParams);
      } else {
        this.setState({
          recordingData: renderParams,
        });
      }

      this.setState({
        width: renderParams.output.width || DEFAULT_VIDEO_WIDTH,
        height: renderParams.output.height || DEFAULT_VIDEO_HEIGHT,
        webmrecording: webmRecording,
        framesdestination: framesDestination,
      });
    }
  };

  render() {
    return (
      <>
        <button id="loadButton" onClick={this.onLoadClicked}>
          Load
        </button>
        {this.state.recordingData ||
        (this.props.recordingData &&
          this.props.getRecordingDataResult.success) ? (
          <VideoRecorder
            recordingData={this.state.recordingData || this.props.recordingData}
            height={this.state.height}
            width={this.state.width}
            webmrecording={this.state.webmrecording}
            framesdestination={this.state.framesdestination}
          ></VideoRecorder>
        ) : (
          <></>
        )}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    getRecordingDataResult: state.recorder.getRecordingDataResult,
    recordingData: state.recorder.recordingData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getRecordingData: (recordingInputUrl) =>
      dispatch(actions.getRecordingDataRequest(recordingInputUrl)),
    loadRecordingImages: (recordingData) =>
      dispatch(actions.loadRecordingImagesRequest(recordingData)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Recorder));
